import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { planEnrollmentService } from "./service";

type IPlanEnrollment = planEnrollmentApiSpec.PlanEnrollment;
type IPlanEnrollmentCreateRequest =
  planEnrollmentApiSpec.operations["enrollPlan"]["requestBody"]["content"]["application/json"];

export const createPlanEnrollment = async (
  request: IPlanEnrollmentCreateRequest
): Promise<IPlanEnrollment> => {
  const { data } = await planEnrollmentService.post(``, request);
  return data;
};
